import React, { FC } from 'react';

import { IconType } from '../icon.type';

const RandomIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 15 15"
      >
        <g clipPath="url(#clip0_11096_46534)">
          <path
            fill="currentColor"
            d="M0 3.75v-.234c0-.193.158-.351.352-.351h3.1c.096 0 .19.04.257.114L6.337 6.12l-.639.691-2.505-2.71H.352A.353.353 0 0 1 0 3.75m14.725 8.163-1.875 1.875c-.59.588-1.6.17-1.6-.662v-1.29h-.753a.35.35 0 0 1-.258-.114L7.611 8.88l.639-.691 2.502 2.71h.498V9.375c0-.835 1.01-1.25 1.6-.662l1.875 1.875a.936.936 0 0 1 0 1.325m-.58-.745L12.27 9.293a.117.117 0 0 0-.2.082v3.75c0 .106.126.159.2.082l1.875-1.875a.113.113 0 0 0 0-.164m.58-6.755L12.85 6.288c-.59.588-1.6.17-1.6-.663V4.102h-.498l-7.043 7.62a.35.35 0 0 1-.258.114h-3.1A.353.353 0 0 1 0 11.485v-.234c0-.194.158-.352.352-.352h2.841l7.043-7.62a.35.35 0 0 1 .258-.114h.756v-1.29c0-.835 1.01-1.25 1.6-.662l1.875 1.875a.935.935 0 0 1 0 1.325m-.58-.745L12.27 1.793a.117.117 0 0 0-.2.082v3.75c0 .106.126.159.2.082l1.875-1.875a.113.113 0 0 0 0-.164"
          ></path>
        </g>
        <defs>
          <clipPath id="clip0_11096_46534">
            <path fill="#fff" d="M0 0h15v15H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default RandomIcon;
